/**
 * Painterly light rig for the Phase 3 placeholder scene.
 *
 * AESTHETIC-BRIEF Rules in play:
 *   Rule 1 — Painterly, baked lighting feel (no PBR authoring).
 *   Rule 2 — One directional sun light; real-time shadows disabled at the <Canvas>
 *            level (Phase 3 turns them off entirely; Phase 5+ may enable them on the
 *            player capsule at <5m only).
 *   Rule 3 — Master palette: warm-ochre / cream / muted-green / slate-blue. The
 *            hemisphere fill uses cream (#FDF6EE) + muted-green (#6B7C4E) to key the
 *            scene; ambient is warm-ochre tinted so unlit sides never go neutral gray.
 */
export function BakedLighting() {
  return (
    <>
      {/* Hemisphere fill — painterly soft-shadow feel; cream sky + muted-green bounce. */}
      <hemisphereLight args={['#FDF6EE', '#6B7C4E', 0.6]} />
      {/* Directional sun — warm afternoon. No shadows in Phase 3. */}
      <directionalLight
        position={[50, 80, 30]}
        intensity={1.2}
        color="#FDF6EE"
        castShadow={false}
      />
      {/* Ambient so unlit sides don't crush to black. Warm-ochre tint keeps the palette locked. */}
      <ambientLight intensity={0.25} color="#E8D5B7" />
    </>
  );
}
